export const InformationIcon = ({ className }: { className: string }) => {
  return (
    <svg
      className={`stroke-current ${className}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.15 2.4a5.75 5.75 0 100 11.5 5.75 5.75 0 000-11.5z"
        stroke="currentColor"
        strokeMiterlimit="10"
      />
      <path
        d="M7.275 7.275h1V10.9"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.9 11.025h2.75"
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M8.15 4.462a.812.812 0 100 1.625.812.812 0 000-1.625z"
        fill="#000"
      />
    </svg>
  );
};
